<template>
  <div class="xhsProductionCenter">
    <EditDialog ref="editRef" @refresh="getList"/>

    <div class="title">小红书商品中心</div>
    <div class="operation">
      <el-button type="primary" @click="handleAdd">新建商品</el-button>
      <div>
        <el-form class="search" ref="form" :model="searchForm" >
          <el-form-item  label-width="80px" label="商品名称">
            <el-input v-model="searchForm.productName" placeholder="请输入" size="small"></el-input>
          </el-form-item>
          <el-form-item label-width="30px">
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleSearchReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="table">
      <el-table v-loading="listLoading" :data="tableData" style="width: 100%"
                :header-cell-style="{ background: '#FCFAF8', fontSize: '16px', fontFamily: 'Alibaba-PuHuiTi-R, Alibaba-PuHuiTi', fontWeight: 'normal', color: '#222222' }">
        <el-table-column label="商品ID" prop="id" align="left" width="100"/>
        <el-table-column label="商品名称" prop="name" align="left" width="250"/>
        <el-table-column label="售价" prop="salePriceBd" align="left" width="120"/>
        <el-table-column label="原价" prop="originPriceBd" align="center" width="120"/>
        <el-table-column label="类目" prop="categoryName" align="center" width="150"/>
        <el-table-column label="创建时间" prop="createTimeStr" align="center" width="200"/>
        <el-table-column label="首页展示" prop="sortBy" align="center" width="200">
          <template slot-scope="{row}">
            <div class="list-edit" v-if="row.isSortByEdit">
              <el-input size="mini" style="width: 50px" v-model="row.editSortBy" ></el-input>
              <div class="edit-btn" @click="handleSortConfirm(row)">
                确认
              </div>
              <div class="edit-btn" @click="handleSortCancel(row)">
                取消
              </div>
            </div>
            <div class="list-edit" v-else>
              <div>{{ row.sortBy || '-' }}</div>
              <div class="edit-btn" @click="handleSortEdit(row)">
                编辑
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="statusStr" align="center" width="100"/>
        <el-table-column label="小红书同步状态" prop="syncStatusStr" align="center"  width="150"/>
        <el-table-column label="操作" width="200" fixed="right" align="left">
          <template slot-scope="{row}">
            <div class="btn-group">
              <div class="btn" @click.stop="handleEdit(row)">编辑</div>
              <div class="btn" @click.stop="handleShelf(row,!row.status)">
                {{ row.status ? '下架' : '上架'}}
              </div>
              <div class="btn" @click.stop="handleDelete(row)">删除</div>
              <div class="btn" @click.stop="handleSync(row)">同步</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <Page :total="total" :current="pageNo" show-sizer show-elevator show-total @on-change="changePage"
            @on-page-size-change="changePagesize"></Page>
    </div>
  </div>
</template>

<script>
import { Page } from 'view-design'
import EditDialog from '@/views/pc/miniProgram/xhsProductionCenter/editDialog.vue'
import debounce from '@/utils/debounce.js'
import Xhs from "@/api/xhs";
const xhsApis = new Xhs();

export default {
  name: '',
  components: { Page,EditDialog },
  props: {},
  data() {
    return {
      searchForm: {
        productName:''
      },
      listLoading: true,
      tableData: [],
      total: 0,
      pageNo: 1,
      pageSize: 10
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getList()
  },
  methods: {
    async handleSearch(){
      debounce(()=>{
        this.getList()
      },500, true)
    },
    async handleSearchReset(){
      debounce(()=>{
        this.searchForm.productName = ''
        this.pageNo = 1
        this.getList()
      },500, true)
    },
    async handleSortConfirm(row){
      const regex = /^(?:[1-6])?$/;
      if(!regex.test(row.editSortBy)){
        this.$message.error('请输入1-6的整数')
        return;
      }

      await this.$confirm(`是否确认修改`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const {data} = await xhsApis.homeSort({
        id: row.id,
        sortBy: row.editSortBy,
      })

      if(!data.success){
        this.$message.error(data.message)
        return;
      }

      this.$message.success('修改成功')
      this.getList()
    },
    handleSortEdit(row){
      row.isSortByEdit = true
    },
    handleSortCancel(row){
      row.isSortByEdit = false
      row.editSortBy = row.sortBy
    },
    async getList() {
      this.listLoading = true
      const ret = await xhsApis.productionPage({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        productNameLike: this.searchForm.productName
      }).finally(()=>{
        this.listLoading = false
      })

      const res = ret.data
      this.tableData = res.data.list.map( item => {
        item.isSortByEdit = false
        item.editSortBy = item.sortBy
        return item
      })

      if (res.data.pageNo === 0) {
        this.total = 0
        this.pageNo = 1
        return;
      }
      this.total = res.data.total
      this.pageNo = res.data.pageNo
      this.pageSize = res.data.pageSize
    },
    handleAdd(){
      this.$refs.editRef.open()
    },
    handleEdit(row){
      this.$refs.editRef.open(row.id)
    },
    async handleShelf(row, operation){
      await this.$confirm(`是否确认${operation?'上架':'下架'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      let ret = null
      if(operation){
        ret = await xhsApis.productUp({
          outSkuId: row.outSkuId,
        })
      }else{
        ret = await xhsApis.productOff({
          outSkuId: row.outSkuId,
        })
      }

      if(!ret.data.success){
        this.$message.error(data.message)
        return;
      }

      this.$message.success(`${operation?'上架':'下架'}成功`)
      this.getList()
    },
    async handleDelete(row){
      if(row.isDefault){
        this.$message.error('默认规则不能删除')
        return;
      }

      await this.$confirm(`是否确认删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      const ret = await xhsApis.productDelete({
        id: row.id
      })

      if(!ret.data.success){
        this.$message.error(data.message)
        return;
      }

      this.$message.success('删除成功')
      this.getList()
    },
    async handleSync(row){
      await this.$confirm(`是否确认同步`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const ret = await xhsApis.productSync({
        id: row.id
      })

      if(!ret.data.success){
        this.$message.error(data.message)
        return;
      }

      this.$message.success('同步成功')
      this.getList()
    },
    changePage(value) {
      this.pageNo = value
      this.getList()
    },
    changePagesize(value) {
      this.pageSize = value
      this.getList()
    }
  }
}
</script>
<style lang='less' scoped>
.xhsProductionCenter {
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  position: relative;

  .list-edit{
    display: flex;
    align-items: center;
    justify-content: center;
    .edit-btn{
      margin-left: 20px;
      color: #007aff;
      cursor: pointer;
    }
  }

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }

  .operation{
    margin-top: 20px;
  }

  .btn-group{
    display: flex;
    gap: 20px;
    .btn{

      color: #007aff;
      cursor: pointer;
    }
  }

  .search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 20px;

    p {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      margin-right: 10px;
    }

    ::placeholder {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #c1c1c1;
    }

    .inputStyle {
      box-sizing: border-box;
      width: 150px;
      height: 32px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #eeeeee;
      padding-left: 10px;
      margin-right: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
    }

    :hover {
      border-color: #57a3f3;
    }

    .searchBtn {
      width: 90px;
      height: 32px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      line-height: 32px;
      color: rgba(255, 255, 255, 0.8);
      // margin-top: 16px;
      margin-left: 20px;
      margin-bottom: 8px;
      margin-top: 8px;
      cursor: pointer;
    }
  }

  .table {
    border: 1px solid #eeeeee;

    .status {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
    }

    .active {
      color: #ff4f76;
    }
  }

  .page {
    // margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/xhsProductionCenter/index.vue